import { EventEmitter } from 'events';
import dispatcher from '../dispatcher/dispatcher';
import pathMapper from '../services/pathMapper';
import connectElements from '../services/svgDrawer';
import uuidv1 from 'uuid/v1';
import { getTree } from '../action/treeAction';


/**
 * Stores all the paths for building up the svg
 */
class PathStore extends EventEmitter {
    constructor() {
        super();
        this.path = [];
        this.relationship = {
           
        };
        this.deletedRelationship = [];
    }
    /**
     * creates the path objects from the relationships object 
     */
    getPaths() {
        this.path = [];
        let pathObj = this.relationship;
        let paths = pathMapper(pathObj);
        this.path = paths;
        this.emit('Path-Changes');
    }
    /**
     * creates a relationship between parent and child
     * creates new relationship if parent isn't already in object
     * @param {*} treeObj 
     */
    createRelationship(treeObj) {
        let id = uuidv1();
        // console.log(treeObj);
        if (this.relationship[treeObj.parent]) {
            this.relationship[treeObj.parent].children.push(treeObj.id);
            console.log(this.relationship[treeObj.parent]);
        } else {
            let entry = {
                id: id,
                parent: treeObj.parent,
                children: [treeObj.id]
            };
            this.relationship[treeObj.parent] = entry;
        }
        // if(treeObj.parent === 0){
        //     this.emit("Relationship-Changes");
        // }
        let self = this;
        setTimeout(function () {
            self.getPaths();
        }, 0);

    }
    //removes all the deleted entries from the relationship
    removeRelationships(relationShipArray) {
        if (this.deletedRelationship === undefined) {
            this.deletedRelationship = [];
        }
        relationShipArray.forEach((element => {
            if (this.relationship[element.relationshipId]) {
                if (element.relationshipId === element.id) {
                    delete this.relationship[element.relationshipId];
                    // if (this.deletedRelationship) {
                    // console.log("in here");
                    this.deletedRelationship.push(element.id);
                    // } else {
                    //     console.log("hello im hjere", relationShipArray);
                    // }
                } else {
                    this.relationship[element.relationshipId].children.forEach((child, index) => {
                        if (child === element.id) {
                            this.relationship[element.relationshipId].children.splice(index, 1);
                            // this.updateRelationship.push(element.id);
                        }
                    });
                }
            }
        }));
        let self = this;
        setTimeout(function () {
            self.getPaths();
            getTree();
            self.pathRedraw();
        });
    }
    /**
     * sets the relationships if retrieved from api
     * @param {*} rObj relationship object
     */
    setRelationships(rObj) {
        this.relationship = rObj.relationships;
        this.deletedRelationship = rObj.deleteRel || [];
        let self = this;
        setTimeout(function () {
            self.getPaths();
        }, 0);
    }
    /**
     * goes through each path in the list and redraws the paths
     * Used for when resizes or a new element is added 
     */
    pathRedraw() {
        this.path.forEach((element => {
            connectElements(element.entry.id, element.entry.startPoint, element.entry.endPoint);
        }));
    }
    actionHandler(action) {
        switch (action.type) {
            case 'GET_PATHS': {
                this.getPaths(action.object);
                break;
            }
            case 'PATH_REDRAW': {
                this.pathRedraw();
                break;
            }
            case 'RELATIONSHIP_BUILDER': {
                this.createRelationship(action.object);
                break;
            }
            case 'DELETE_RELATIONSHIPS': {
                this.removeRelationships(action.object);
                break;
            }
            case 'SET_RELATIONSHIPS': {
                this.setRelationships(action.object);
                break;
            }
            default: {
                break;
            }
        }
    }
}

const pathStore = new PathStore();
dispatcher.register(pathStore.actionHandler.bind(pathStore));

export default pathStore;


// WEBPACK FOOTER //
// ./src/store/pathStore.js